(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaiora-editorial-home"] && !Shopify.designMode) return;
  try {
    
function initializeGaioraHomeFilm(root) {
  root.querySelectorAll('[data-home-film]').forEach((player) => {
    if (player.dataset.filmBound) return;
    player.dataset.filmBound = 'true';
    const video = player.querySelector('video');
    const toggle = player.querySelector('[data-film-toggle]');
    const sound = player.querySelector('[data-film-sound]');
    const zh = document.documentElement.lang.startsWith('zh');
    let userPaused = false;
    let visible = false;
    video.muted = true;
    function update() {
      player.classList.toggle('is-paused', video.paused);
      player.classList.toggle('has-sound', !video.muted);
      toggle.setAttribute('aria-label', video.paused ? (zh ? '播放影片' : 'Play video') : (zh ? '暫停影片' : 'Pause video'));
      sound.setAttribute('aria-label', video.muted ? (zh ? '開啟聲音' : 'Turn sound on') : (zh ? '關閉聲音' : 'Turn sound off'));
      sound.setAttribute('aria-pressed', String(!video.muted));
    }
    function play() { video.play().catch(update); }
    toggle.addEventListener('click', () => {
      userPaused = !video.paused;
      if (userPaused) video.pause(); else play();
    });
    sound.addEventListener('click', () => { video.muted = !video.muted; update(); });
    ['play', 'pause', 'volumechange'].forEach((event) => video.addEventListener(event, update));
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !userPaused && !document.hidden) play(); else video.pause();
    }, { threshold: 0.25 });
    observer.observe(player);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause(); else if (visible && !userPaused) play();
    });
    update();
  });
}
initializeGaioraHomeFilm(document);
document.addEventListener('shopify:section:load', (event) => initializeGaioraHomeFilm(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
